import { debounce as q } from "@yeger/debounce";
function G({
  columns: u,
  columnWidth: l,
  emit: d,
  gap: w,
  items: g,
  maxColumns: v,
  minColumns: f,
  nextTick: k,
  onBeforeUnmount: Y,
  onMounted: D,
  rtl: y,
  scrollContainer: h,
  ssrColumns: s,
  vue: E,
  wall: i,
  watch: p
}) {
  function b(t, e, r, n) {
    const o = R(r);
    return n + e + o <= t ? b(
      t,
      e,
      r + 1,
      n + e + o
    ) : r;
  }
  function R(t) {
    const e = Array.isArray(l.value) ? l.value : [l.value];
    return e[t % e.length];
  }
  function S() {
    const t = b(
      i.value.getBoundingClientRect().width,
      w.value,
      0,
      // Needs to be offset my negative gap to prevent gap counts being off by one
      -w.value
    ), e = j(_(t));
    return e > 0 ? e : 1;
  }
  function _(t) {
    const e = v == null ? void 0 : v.value;
    return e && t > e ? e : t;
  }
  function j(t) {
    const e = f == null ? void 0 : f.value;
    return e && t < e ? e : t;
  }
  if (s.value > 0) {
    const t = M(s.value);
    g.value.forEach(
      (e, r) => t[r % s.value].push(r)
    ), u.value = t;
  }
  let T = 0;
  async function B(t, e) {
    if (t >= g.value.length || (await k(), T !== e))
      return;
    const r = [...i.value.children];
    y.value && r.reverse();
    const n = r.reduce(
      (o, A) => A.getBoundingClientRect().height < o.getBoundingClientRect().height ? A : o
    );
    u.value[+n.dataset.index].push(t), await B(t + 1, e);
  }
  async function c(t = !1) {
    const e = S();
    if (u.value.length === e && !t) {
      d(E === 2 ? "redraw-skip" : "redrawSkip");
      return;
    }
    u.value = M(e);
    const r = h == null ? void 0 : h.value, n = r ? r.scrollTop : window.scrollY;
    await B(0, ++T), r ? r.scrollBy({ top: n - r.scrollTop }) : window.scrollTo({ top: n }), d("redraw");
  }
  const a = typeof ResizeObserver > "u" ? void 0 : new ResizeObserver(q(() => c()));
  return D(() => {
    c(), a == null || a.observe(i.value);
  }), Y(() => a == null ? void 0 : a.unobserve(i.value)), p([g, y], () => c(!0)), p([l, w, f, v], () => c()), { getColumnWidthTarget: R };
}
function M(u) {
  return Array.from({ length: u }).map(() => []);
}
export {
  G as useMasonryWall
};
